export default "__VITE_ASSET__Bsg6sXYM__"